import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import { getCommentList } from "../../features/slices/feedmanagement";
import { useSelector } from "react-redux";
import heartPic from "../../assets/images/heart.png";
import profile from "../../assets/images/profile-1.png";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
const CommentListModal = ({ handleCommentClose, id }) => {
  const dispatch = useDispatch();
  const { commentList } = useSelector((state) => state.feed);
  useEffect(() => {
    dispatch(getCommentList({ postId: id }));
  }, []);
  const handleClose = () => {
    handleCommentClose();
  };
  const handleDelete = () => {
    // Trigger the modal open logic here
    // You can add the modal opening logic here, or use a state to control modal visibility
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Comment</h3>

          <div className="CommentBox">
            {commentList?.result?.length > 0 ? (
              commentList?.result?.map((da) => {
                return (
                  <aside key={da?._id}>
                    <figure>
                      <img
                        src={da?.commentedUserData?.[0]?.profilePic || profile}
                        alt=""
                        style={{
                          objectFit: "contain",
                          width: "48px",
                          height: "48px",
                        }}
                      />
                      <figcaption>
                        <h4>
                          {da?.commentedUserData?.[0]?.fullName}
                          {" ,"}
                          <span>
                            {moment(
                              da?.commentedUserData?.[0]?.createdAt
                            ).fromNow()}
                          </span>
                        </h4>
                        <p
                          style={{
                            textAlign: "left",
                          }}
                        >
                          {da?.text}
                        </p>
                        {/* <a href="javascript:void(0);">Reply</a>
                                      <div class="ReplyBox">
                                          <input type="text"> <p>View 2 Reply</p>
                                      </div> */}
                      </figcaption>
                    </figure>
                    <div className="d-flex align-items-start">
                      <ul>
                        <li>
                          <a
                            href="javascript:void(0);"
                            style={{
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <img
                              src={heartPic}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </a>
                          &nbsp;{da?.likeCount}
                        </li>
                      </ul>
                      {/* <Dropdown className="ml-2">
                        <Dropdown.Toggle
                          id="dropdownMenuLink"
                          className="custom-dropdown-toggle"
                          style={{
                            background: "transparent",
                            color: "black",
                            border: "none",
                            paddingTop: 0,
                          }}
                        >
                          <i className="fa-solid fa-ellipsis-vertical" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item onClick={handleDelete}>
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown> */}
                    </div>
                  </aside>
                );
              })
            ) : (
              <p className="d-flex justify-content-center">No comment</p>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CommentListModal;
